/* fg-cart-image.js — swaps the customizer's snapshot of the configured bottle into the cart
   drawer + cart page. Pairs with fg-customizer.js, which on add-to-cart captures the 3D canvas
   to localStorage keyed by the new cart line key(s).

   Include once, site-wide (covers the cart page AND the drawer), in layout/theme.liquid:
     <script src="{{ 'fg-cart-image.js' | asset_url }}" defer></script>

   Checkout has no custom JS, so it falls back to the product's placeholder image (by design).

   Tuned to this Dawn-based theme: rows are <tr class="cart-item"> rendered in cart.items order,
   the image is img.cart-item__image. Drawer = #CartDrawer-CartItems (no key in DOM -> positional
   mapping), cart page = #main-cart-items (remove link carries the line key -> key fallback). */
(function () {
  'use strict';
  var PREFIX = 'fg_cart_thumb_';

  function ls(k) { try { return k && localStorage.getItem(k); } catch (e) { return null; } }
  // Prefer the unique bundle id (stamped on the merged line by the cart-transform as
  // _wick_bundle_id) so two bundles built on the SAME parent variant each keep their own image.
  // Fall back to the cart-line key for older carts where the transform isn't redeployed yet.
  function thumbForItem(it) { var id = (it.properties || {})._wick_bundle_id; return (id && ls(PREFIX + 'b_' + id)) || ls(PREFIX + it.key); }
  function srcForItem(it)   { var id = (it.properties || {})._wick_bundle_id; return (id && ls('fg_cart_src_b_' + id)) || ls('fg_cart_src_' + it.key); }
  function summaryForItem(it) { var id = (it.properties || {})._wick_bundle_id; if (!id) return null; try { var s = ls('fg_cart_sum_b_' + id); return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function thumbFor(key) { return ls(PREFIX + key); }
  function srcFor(key) { return ls('fg_cart_src_' + key); }

  // one-time unscoped CSS for the under-title notes (cart lines aren't inside .fgc-root)
  (function () { if (document.getElementById('fgc-cart-notes-css')) return;
    var st = document.createElement('style'); st.id = 'fgc-cart-notes-css';
    st.textContent = '.fgc-cart-notes{list-style:none;margin:6px 0 2px;padding:0;font-size:12px;line-height:1.55;color:#777}.fgc-cart-notes li{margin:0}.fgc-cart-notes-k{color:#9a958f}';
    document.head.appendChild(st); })();

  // render the build summary as a small list under the bundle line's title
  function addNotes(row, summary) {
    if (!row || !summary || !summary.length) return;
    var details = row.querySelector('.cart-item__details'); if (!details) return;
    if (details.querySelector('.fgc-cart-notes')) return; // already added (avoids observer loops)
    var ul = document.createElement('ul'); ul.className = 'fgc-cart-notes';
    summary.forEach(function (s) {
      var li = document.createElement('li');
      var k = document.createElement('span'); k.className = 'fgc-cart-notes-k'; k.textContent = s[0] + ': ';
      li.appendChild(k); li.appendChild(document.createTextNode(s[1] == null ? '' : s[1])); ul.appendChild(li);
    });
    var name = details.querySelector('.cart-item__name');
    if (name && name.parentNode) name.parentNode.insertBefore(ul, name.nextSibling); else details.appendChild(ul);
  }

  // point the bundle line's product links back to the product the shopper customised from
  function relink(row, url) {
    if (!row || !url) return;
    var as = row.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < as.length; i++) { as[i].setAttribute('href', url); as[i].setAttribute('data-fg-relink', '1'); }
  }

  function imgIn(row) {
    return row.querySelector('img.cart-item__image') ||
           row.querySelector('.cart-item__media img') ||
           row.querySelector('img');
  }

  function swap(row, dataURL) {
    if (!row || !dataURL) return;
    var img = imgIn(row);
    if (img) {
      if (img.getAttribute('data-fg-thumb') === dataURL) return; // already done
      var pic = img.closest && img.closest('picture');
      if (pic) { var s = pic.querySelectorAll('source'); for (var i = 0; i < s.length; i++) s[i].remove(); }
      img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.removeAttribute('sizes');
      img.src = dataURL; img.srcset = '';
      img.setAttribute('data-fg-thumb', dataURL); // marker so we don't re-swap our own mutations
      return;
    }
    // No <img> at all — the customisable parent product has no image, so the media cell is empty.
    // Inject our snapshot so the bundle line still shows the configured bottle.
    var media = row.querySelector('.cart-item__media') || row.querySelector('[class*="media"]') ||
                row.querySelector('td, .cart-item__image-container');
    if (!media || media.querySelector('img[data-fg-thumb]')) return;
    var el = document.createElement('img');
    el.className = 'cart-item__image';
    el.setAttribute('data-fg-thumb', dataURL);
    el.setAttribute('width', '150'); el.setAttribute('height', '188');
    el.loading = 'lazy';
    el.alt = '';
    el.src = dataURL;
    media.appendChild(el);
  }

  // cart scopes present on the page (drawer and/or main cart), processed independently so their
  // row sets never get mixed (both can be in the DOM at once on /cart).
  function scopes() {
    var out = [];
    var drawer = document.querySelector('#CartDrawer-CartItems, cart-drawer-items');
    if (drawer) out.push(drawer);
    var page = document.querySelector('#main-cart-items');
    if (page && page !== drawer) out.push(page);
    if (!out.length) out.push(document);
    return out;
  }

  function rowsIn(scope) {
    var els = scope.querySelectorAll('tr.cart-item, .cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]');
    return Array.prototype.slice.call(els);
  }

  function apply() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var thumbs = items.map(thumbForItem);
        var srcs = items.map(srcForItem);
        var sums = items.map(summaryForItem);
        if (window.FG_CART_IMG_DEBUG === true) { // opt-in: window.FG_CART_IMG_DEBUG = true
          console.log('[FG-cart] lines', items.map(function (i) { return i.title + ' [' + ((i.properties || {})._wick_bundle_id || i.key) + '] thumb=' + (thumbForItem(i) ? 'YES' : 'no'); }));
          console.log('[FG-cart] stored keys', Object.keys(localStorage).filter(function (k) { return k.indexOf(PREFIX) === 0; }).map(function (k) { return k.replace(PREFIX, ''); }));
        }
        if (!thumbs.some(Boolean) && !srcs.some(Boolean) && !sums.some(Boolean)) return;

        scopes().forEach(function (scope) {
          var rows = rowsIn(scope);
          if (rows.length === items.length) {
            // positional map (cart.items order == DOM order in Dawn) — works for drawer & page
            for (var i = 0; i < items.length; i++) { if (thumbs[i]) swap(rows[i], thumbs[i]); if (srcs[i]) relink(rows[i], srcs[i]); if (sums[i]) addNotes(rows[i], sums[i]); }
          } else {
            // fallback: match by line key in a remove link / attribute (cart page)
            items.forEach(function (it, i) {
              if (!thumbs[i] && !srcs[i] && !sums[i]) return;
              var hit = scope.querySelector('[href*="' + it.key + '"],[data-key="' + it.key + '"]');
              var row = hit && (hit.closest('tr.cart-item, .cart-item') || hit.parentElement);
              if (row) { if (thumbs[i]) swap(row, thumbs[i]); if (srcs[i]) relink(row, srcs[i]); if (sums[i]) addNotes(row, sums[i]); }
            });
          }
        });
      })
      .catch(function () {});
  }

  var t; function schedule() { clearTimeout(t); t = setTimeout(apply, 120); }

  if (document.readyState !== 'loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
  ['cart:refresh', 'cart:updated', 'cart:build', 'cart:open'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
  // catch Dawn's drawer render + line re-renders (section rendering replaces the row HTML)
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  [400, 1000, 2000].forEach(function (ms) { setTimeout(apply, ms); });
})();
